export default "__VITE_ASSET__f8f09b17__"